import { memo } from 'react';
import styled from '@emotion/styled';
import usePromoteDays, { PROMOTE_I18N_NS } from 'hooks/business/usePromoteDays';
import bgPic from './bg.png';
import { T } from '@tolgee/react';
import { i18nExist } from 'services/i18n/utils';

export interface PromoteBannerProps {}

const Bar = styled.div`
  background: #d0dfff url(${bgPic});
  height: 88px;
  padding-left: 120px;
  background-size: contain;
  background-repeat: no-repeat;
  font-size: 28px;
  color: #1754bb;
  border-radius: 4px;
  font-family: microsoft YaHei;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  > strong {
    position: relative;
    top: 3px;
    color: #f26b72;
    margin: 0 0.2em;
    font-size: 40px;
  }
`;
const Time = styled.p`
  font-size: 12px;
  color: #264272;
`;

const PromoteBanner = (props: PromoteBannerProps) => {
  const { inPromoteRange, config } = usePromoteDays();
  const shouldShow = config?.activityType === 'PACKAGE_ACTIVITY';
  if (!inPromoteRange || !shouldShow) {
    return null;
  }

  return i18nExist('promote.banner.text', PROMOTE_I18N_NS) ? (
    <Bar>
      <T
        ns={PROMOTE_I18N_NS}
        keyName="promote.banner.text"
        params={{ n: 3, strong: <strong /> }}
        defaultValue=""
      />
      <Time>
        <T ns={PROMOTE_I18N_NS} keyName="promote.banner.time.range" />
      </Time>
    </Bar>
  ) : null;
};
export default memo(PromoteBanner);
